import { render } from "./preProduction.vue?vue&type=template&id=cc00332a"
import script from "./preProduction.vue?vue&type=script&lang=js"
export * from "./preProduction.vue?vue&type=script&lang=js"

import "./preProduction.vue?vue&type=style&index=0&id=cc00332a&lang=css"
script.render = render

export default script